import { Stack } from "@mui/material";
import { FC, ReactNode } from "react";
import { ICPSectionTitle } from "../ICPSectionTitle";

interface ICPFirmographicsAnalysisSectionProps {
  children: ReactNode;
}

/**
 * Minimal wrapper component for ICP Firmographics Analysis section
 * Contains the section title and wrapper for child components
 */
export const ICPFirmographicsAnalysisSection: FC<
  ICPFirmographicsAnalysisSectionProps
> = ({ children }) => {
  return (
    <Stack gap={2} marginTop={0}>
      <ICPSectionTitle>Firmographics Analysis</ICPSectionTitle>
      {children}
    </Stack>
  );
};
